import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { PdpGalleryCarouselComponent } from './pdp-gallery-carousel.component'
import { CmsDirectivesModule } from '../../../cms/directives/cms-directives.module'

@NgModule({
  declarations: [PdpGalleryCarouselComponent],
  imports: [
    CommonModule,
    NgbModule,
    MbI18nModule,
    CmsDirectivesModule,
  ],
  exports: [PdpGalleryCarouselComponent]
})
export class PdpGalleryCarouselModule {}
